import { CircularProgress } from '@mui/material';
import CustomButton from 'common/components/CustomButton';
import YesNoDialog from 'common/components/YesNoDialog';
import { backfillEmbeddings } from 'common/services/embeddingService';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const BackfillEmbeddingsAction = ({ entityType }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleConfirm = useCallback(async () => {
        setConfirmOpen(false);
        setLoading(true);
        try {
            const { data } = await backfillEmbeddings(entityType);
            enqueueSnackbar(
                t('backfillEmbeddings.success', { count: data?.requested ?? 0 }),
                { variant: 'success' },
            );
        } catch (error) {
            enqueueSnackbar(t('backfillEmbeddings.error'), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    }, [enqueueSnackbar, entityType, t]);

    return (
        <>
            <CustomButton disabled={loading} onClick={() => setConfirmOpen(true)}>
                {loading ? (
                    <CircularProgress size={16} color="inherit" />
                ) : (
                    <span>{t('backfillEmbeddings.button').toUpperCase()}</span>
                )}
            </CustomButton>
            <YesNoDialog
                openDialog={confirmOpen}
                title={t('backfillEmbeddings.confirmTitle')}
                messageToConfirm={t('backfillEmbeddings.confirmMessage')}
                yesButtonCallback={handleConfirm}
                noButtonCallback={() => setConfirmOpen(false)}
            />
        </>
    );
};

export default BackfillEmbeddingsAction;
